"use client";

import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

interface GaugeChartProps {
  value: number; // 0-100の値
}

// Constants
const GAUGE_COLORS = {
  high: "#22c55e", // 緑（高確率）
  medium: "#eab308", // 黄色（中確率）
  low: "#ef4444", // 赤（低確率）
  background: "#e5e7eb", // グレー（残り）
};

// Helpers
function getGaugeColor(value: number): string {
  if (value >= 70) return GAUGE_COLORS.high;
  if (value >= 40) return GAUGE_COLORS.medium;
  return GAUGE_COLORS.low;
}

export function GaugeChart({ value }: GaugeChartProps) {
  const data = [
    { name: "Value", value: value },
    { name: "Remaining", value: 100 - value },
  ];

  const color = getGaugeColor(value);

  return (
    <div className="relative w-full h-full min-h-[200px] flex flex-col items-center justify-center">
      <div className="w-full h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="100%"
              startAngle={180}
              endAngle={0}
              innerRadius="60%"
              outerRadius="80%"
              paddingAngle={0}
              dataKey="value"
              stroke="none"
            >
              <Cell fill={color} />
              <Cell fill={GAUGE_COLORS.background} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="absolute top-[85%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
        <div className="text-3xl font-bold" style={{ color }}>
          {Math.round(value)}
        </div>
        <div className="text-xs text-muted-foreground">/ 100</div>
      </div>
    </div>
  );
}
